import React from 'react'
import InnerBanner from './InnerBanner';

const Historicplaces = ()=>{
    return(
        <div>
          <InnerBanner />
          <h1>Hii</h1>

        </div>
    )
}

export default Historicplaces;